module.exports = __webpack_public_path__ + "static/media/setup_guide_illustration.1f374edd.png";